"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _framerMotion = require("framer-motion");
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
var _overlayContext = _interopRequireDefault(require("./context/overlayContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = function useStyles(_ref) {
  var fullscreen = _ref.fullscreen,
    isMobile = _ref.isMobile,
    nativeFullscreen = _ref.nativeFullscreen;
  if (isMobile) {
    return (0, _makeStyles.default)(function (theme) {
      var _theme$zIndex;
      return {
        container: {
          alignItems: "center",
          bottom: 0,
          display: "flex",
          height: "100%",
          justifyContent: "center",
          left: 0,
          maxHeight: !fullscreen ? "90vh" : "100%",
          position: "fixed",
          right: 0,
          top: "auto",
          zIndex: theme === null || theme === void 0 ? void 0 : (_theme$zIndex = theme.zIndex) === null || _theme$zIndex === void 0 ? void 0 : _theme$zIndex.modal
        }
      };
    })();
  }
  return (0, _makeStyles.default)(function (theme) {
    var _theme$zIndex2;
    return {
      container: {
        alignItems: "center",
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        left: 0,
        padding: !fullscreen && !nativeFullscreen ? theme === null || theme === void 0 ? void 0 : theme.spacing(3) : 0,
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: theme === null || theme === void 0 ? void 0 : (_theme$zIndex2 = theme.zIndex) === null || _theme$zIndex2 === void 0 ? void 0 : _theme$zIndex2.modal
      }
    };
  })();
};
var Container = function Container(props) {
  var _useContext = (0, _react.useContext)(_overlayContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    overlayProps = _useContext2[0];
  var classes = overlayProps.classes,
    fullscreen = overlayProps.fullscreen,
    isMobile = overlayProps.isMobile,
    nativeFullscreen = overlayProps.nativeFullscreen,
    setOpen = overlayProps.setOpen;
  var css = useStyles({
    fullscreen: fullscreen,
    isMobile: isMobile,
    nativeFullscreen: nativeFullscreen
  });
  (0, _react.useEffect)(function () {
    if (nativeFullscreen && window.innerWidth > 500) {
      var exitHandler = function exitHandler() {
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
          setOpen(false);
        }
      };
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
      if (document.addEventListener) {
        document.addEventListener("fullscreenchange", exitHandler, false);
        document.addEventListener("mozfullscreenchange", exitHandler, false);
        document.addEventListener("MSFullscreenChange", exitHandler, false);
        document.addEventListener("webkitfullscreenchange", exitHandler, false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nativeFullscreen]);
  return /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    initial: {
      y: isMobile ? window.innerHeight : 50,
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    transition: {
      type: "spring",
      bounce: 0
    },
    className: (0, _clsx.default)("mco-overlay-container", css.container, classes === null || classes === void 0 ? void 0 : classes.container)
  }, props.children);
};
var _default = Container;
exports.default = _default;